"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.openWenJuan = void 0;
var dot_1 = __importDefault(require("dot"));
var tools_1 = require("../tools");
var wenjuan_dot_1 = __importDefault(require("./wenjuan.dot"));
var closeimg_1 = require("./closeimg");
var cookie_1 = __importDefault(require("../cookie"));
function openWenJuan() {
    if (cookie_1["default"].get('quotedelaytip_wenjuan_never')) { //不再提醒
        return false;
    }
    var html = dot_1["default"].compile(wenjuan_dot_1["default"])({
        ismobile: (0, tools_1.isMobile)(),
        close_img: closeimg_1.close_img
    });
    var div = document.createElement('div');
    div.innerHTML = html;
    document.body.appendChild(div);
    //绑定事件
    //关闭
    div.querySelector('#quotedelaytip_close').addEventListener('click', function () {
        document.body.removeChild(div);
    });
    //设置不再提醒
    div.querySelector('#quotedelaytip_never_input').addEventListener('change', function () {
        var ischecked = div.querySelector('#quotedelaytip_never_input').checked;
        if (ischecked) {
            cookie_1["default"].set('quotedelaytip_wenjuan_never', '1', 7, '.eastmoney.com');
        }
        else {
            cookie_1["default"].del('quotedelaytip_wenjuan_never', '.eastmoney.com');
        }
    });
}
exports.openWenJuan = openWenJuan;
